import React, { useContext } from "react";

import { Box, Flex, useTheme } from "@chakra-ui/react";
import { ShareButtonsDefaultFragment } from "./__generated/ShareButtons.generated";
import { getButton } from "./utils";
import { IPageProviderContext, PageProviderContext } from "@src/components/PageProvider";

export interface IShareButtonsProps
  extends Omit<ShareButtonsDefaultFragment, "__typename"> {
  title?: string;
  description?: string;
  images?: any[];
  slug?: string;
  theme?: "default" | "dark" | "light";
  preCopy?: string;
  href?: string;
  items: any;
}

const ShareButtons: React.FC<IShareButtonsProps> = ({
  items,
  title,
  description,
  images,
  slug,
  theme,
  preCopy,
  href,
}) => {
  const size = 35;
  const chakraTheme = useTheme();
  const fontColor =
    theme === "dark" ? chakraTheme.colors["brandPrimary"]["500"] : "#FFFFFF";

    const pageData = useContext<IPageProviderContext | null>(PageProviderContext);

  //buttonStyle.backgroundColor =
  //theme === "dark" ? "#FFFFFF" : "brandPrimary.500";
  const host = href || process.env.NEXT_PUBLIC_VERCEL_URL; // this is for storybook only

  const pageUrl = host ? `https://${host}/${pageData?.parentPageSlug}/${slug}` : "";

  if (items && items.length > 0) {
    const buttons: any = items?.map((itm: any, i: number) =>
      getButton({
        itm,
        i,
        description,
        fontColor,
        pageUrl,
        size,
        theme,
        title,
        images,
      })
    );

    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        padding={4}
        gap={2}
        flexDirection={["column"]}
        width={["100%", "100%", "auto"]}
      >
        <Box fontWeight="bold">{preCopy}</Box>
        <Flex
          justifyContent="center"
          alignItems="center"
          gap={3}
          padding={2}
          flexDirection={["column", "row"]}
          flexWrap="wrap"
          width={["100%", "100%"]}
          maxH={["200px", "100%"]}
          maxW={["200px", "100%"]}
        >
          {buttons}
        </Flex>
      </Flex>
    );
  }

  return <></>;
};

export default ShareButtons;
